import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Btn, Input, Field } from "@/components/common";
import { AuthShell } from "@/pages/Login";
import { api, apiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set a new password" sub="Choose a new password for your account.">
      {!token ? (
        <div className="text-sm p-4" style={{ color: "var(--si-danger)", border: "1px solid var(--si-danger)", borderRadius: 2 }}>
          Missing or invalid reset link.
        </div>
      ) : (
        <form onSubmit={submit}>
          <Field label="New password" hint="At least 6 characters."><Input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></Field>
          <Btn data-testid="reset-submit" type="submit" variant="primary" className="w-full" disabled={loading}>{loading ? "Saving…" : "Reset password"}</Btn>
        </form>
      )}
      <div className="mt-5 text-sm text-center">
        <Link to="/login" style={{ color: "var(--si-silver)" }}>Back to sign in</Link>
      </div>
    </AuthShell>
  );
}
